import listActions from 'src/modules/event/list/eventListActions';
import EventService from 'src/modules/event/eventService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'EVENT_PUBLISH';

const eventPublishActions = {
  PUBLISH_STARTED: `${prefix}_PUBLISH_STARTED`,
  PUBLISH_SUCCESS: `${prefix}_PUBLISH_SUCCESS`,
  PUBLISH_ERROR: `${prefix}_PUBLISH_ERROR`,

  PUBLISH_ALL_STARTED: `${prefix}_PUBLISH_ALL_STARTED`,
  PUBLISH_ALL_SUCCESS: `${prefix}_PUBLISH_ALL_SUCCESS`,
  PUBLISH_ALL_ERROR: `${prefix}_PUBLISH_ALL_ERROR`,
  
  doPublishAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: eventPublishActions.PUBLISH_ALL_STARTED,
      });
    
      const result = await EventService.publishAll(ids);

      dispatch({
        type: eventPublishActions.PUBLISH_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.event.publishAll.success', result.count),
      );
      
      getHistory().push('/event');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventPublishActions.PUBLISH_ALL_ERROR,
      });
    }
  },
};

export default eventPublishActions;
